/// <reference path="../../../../../../shared/utils/View.ts"/>
/// <reference path="../../../../../../shared/models/generated/MitgliedschaftAnlageResponseApi.d.ts"/>
/// <reference path="../../../../../../shared/models/generated/MitgliedschaftAnlagePersonResponseApi.d.ts"/>
/// <reference path="../../../../../../shared/models/generated/WalletProxyQrCodeResponseModelApi.d.ts"/>
/// <reference path="../../../../../../shared/models/generated/WalletProxyUrlResponseModelApi.d.ts"/>
/// <reference path="../../../../../../shared/models/generated/WalletProxyJsonResponseModelApi.d.ts"/>
/// <reference path="../../../../../../shared/models/generated/WalletProxyRequestModelApi.ts"/>

import { BasicUserService } from '../../../../../../shared/services/BasicUserService';
import { CooperationService } from "../../../../../../shared/services/CooperationService";
import { AppPersistenceService } from '../../services/AppPersistenceService';
import { AppViewService } from '../../services/AppViewService';
import { User } from "../../../../../../shared/models/api/User/User";
import { AppModelAdapter } from '../../helper/AppModelAdapter';
import { ContractInfo } from '../../../../../../shared/models/api/User/ContractInfo';
import { AppApiService } from '../../services/AppApiService';
import { RequestModelApi } from "../../../../../../shared/models/generated/WalletProxyRequestModelApi";
import { MglArtApi } from '../../../../../../shared/models/generated/PersonMglArtApi';
import { AppUtils } from '../../../../../../shared/utils/index';

interface AnlagePersonResponseApiExtended extends AnlagePersonResponseApi {
	HasError: boolean;
	HatAbweichendeAnschrift: boolean;
}

export class ConfirmationPageController implements StepController {
	private readonly parent: AppController;
	private readonly options: MglAddMembersAppOptions;
	private readonly user: User;
	private readonly successResponse: AnlageResponseApi;
	private readonly appViewService: AppViewService;
	private readonly appPersistenceService: AppPersistenceService;
	private readonly appApiService: AppApiService;
	private readonly userService: BasicUserService<MglAddMembersAppDefinition>;
	private readonly cooperationService: CooperationService<MglAddMembersAppDefinition>;
	private readonly $ctx: JQuery;
	//private readonly appApiService: AppApiService;

	constructor(parent: AppController, options: MglAddMembersAppOptions, user: User, loader: BasicLoader<MglAddMembersAppDefinition>, successResponse: ApiResponse<AnlageResponseApi>) {
		this.parent = parent;
		this.options = options;
		this.user = user;
		this.$ctx = $(options.$ctx);
		this.successResponse = successResponse.Data;
		this.appViewService = new AppViewService(options, loader);
		this.appPersistenceService = new AppPersistenceService(options);
		this.userService = new BasicUserService(options);
		this.appApiService = new AppApiService(options);

		if (this.options.app.iscooperation) {
			this.cooperationService = new CooperationService(this.options);
		}
	}

	/**
	 * receives view options and calls global view service for initial rendering
	 */
	public start(): void {
		const viewConfig = {
			data: this.getViewOptions(),
			templateurl: this.options.app.currenttemplate.templateurl,
			parent: this,
			$ctx: this.$ctx,
			options: this.options,
			callback: this.afterRenderApp
		};

		this.appViewService.render(viewConfig);
	}

	/**
	 * returns view options for calclator page.
	 * only variables defined in here are available in the view to use with handlebars.
	 */
	private getViewOptions(): { [key: string]: any } {
		const appModel = this.appPersistenceService.getApplicationModel();
		this.updateChilds(this.successResponse.JungeErwachsene || [], this.user.UserData.Anschrift.StrasseHausnummer);
		this.updateChilds(this.successResponse.Kinder || [], this.user.UserData.Anschrift.StrasseHausnummer);
		const cooperationModel = this.options.app.iscooperation ? this.cooperationService.getDynamicFieldsFromStore() : {};
		const partnerAdvertisingData = this.appPersistenceService.getPartnerAdvertisingDataFromStorage();

		return {
			HideEdit: true,
			HideBirthday: true,
			ShowMembershpNumberInput: true,
			IsPartneradvertising: this.options.app.ispartneradvertisement,
			productActiveModel: partnerAdvertisingData.productActiveModel,
			hasCopayment: this.appPersistenceService.hasCopayment(),
			User: this.user,
			FormModel: appModel.FormModel,
			Antragssteller: AppModelAdapter.getAntragsstellerModel(this.user),
			Partner: this.successResponse.Partner ? AppModelAdapter.getPartnerViewModel(this.successResponse.Partner) : undefined,
			JungeErwachsene: this.successResponse.JungeErwachsene,
			Kinder: this.successResponse.Kinder,
			TarifBeschreibung: ContractInfo.getDescription(this.options.app.ratenamemappings, appModel.ContractInfoModel.TarifCodeId),
			IsWalletTarif: this.isTarifValidForWallet(appModel.ContractInfoModel.Tarif),
			Beitrag: appModel.ContractInfoModel.Beitrag,
			iscooperation: this.options.app.iscooperation !== undefined ? this.options.app.iscooperation : false,
			CooperationModel: cooperationModel,
			Bonus: appModel.FormModel.Bonus
		};
	}

	private updateChilds(data: Array<AnlagePersonResponseApi>, StrasseHausnummerMitglied: string): void {
		data.forEach((child) => {
			(child as AnlagePersonResponseApiExtended).HasError = !!child.Message;
			(child as AnlagePersonResponseApiExtended).HatAbweichendeAnschrift = child.Anschrift.StrasseHausnummer !== StrasseHausnummerMitglied;
		});
	}

	public afterRenderApp(): void {
		T.Utils.Tracking.pushKameleoonData();
		this.parent.afterRenderApp();
		const appModel = this.appPersistenceService.getApplicationModel();
		if (this.isTarifValidForWallet(appModel.ContractInfoModel.Tarif)) {
			this.checkWallet();
		}
		this.appPersistenceService.clearApplicationSession();
		if (this.options.app.iscooperation) {
			this.cooperationService.clearSession();
		}
		this.userService.invalidate();
		S.Lazy.init();
		AppUtils.View.scrollTop();
	}

	private checkWallet(): void {
		if (this.appViewService.hasWalletBlock()) {
			this.appApiService.checkWalletMglPass(this.hasWalletSuccess.bind(this), this.hasWalletError.bind(this));
		}
	}

	private hasWalletSuccess(response: ApiResponse<JsonResponseModelApi>): void {
		if (response && response.Data) {
			this.appApiService.updateWalletPass(new RequestModelApi({ AdacPassId: response.Data.adacpassid, Tag: "mitgliedschaft", Werbeeinwilligung: true }),
				// eslint-disable-next-line @typescript-eslint/no-empty-function
				() => { }, this.hasWalletError.bind(this)).done(() => {
					this.appApiService.getWalletQrCode(this.onWalletQrCodeSuccess.bind(this), this.onWalletAppUrlDataError.bind(this)).done(() => {
						this.appApiService.getWalletAppUrl(this.onWalletAppUrlSuccess.bind(this), this.onWalletAppUrlDataError.bind(this));
					});
				});
		}
	}

	private onWalletQrCodeSuccess(response: ApiResponse<QrCodeResponseModelApi>): void {
		if (response && response.Data) {
			this.appViewService.setQrCode(response.Data.ContentType, response.Data.Content);
		}
	}

	private onWalletAppUrlSuccess(response: ApiResponse<UrlResponseModelApi>): void {
		if (response && response.Data) {
			this.appViewService.setWalletAppUrl(response.Data.Url);
		}
	}

	private onWalletAppUrlDataError(): void {
		this.appViewService.hideWalletBlock();
	}

	private hasWalletError(): void {
		this.appViewService.hideWalletBlock();
	}

	private isTarifValidForWallet(tarif: MglArtApi): boolean {
		if (tarif && (tarif === MglArtApi.PAR || tarif === MglArtApi.JUV || tarif === MglArtApi.KIN)) {
			return false;
		}
		return true;
	}
}
